import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import moment from "moment";
import { useSelector } from "react-redux";
import placeholder from "../../assets/images/fashion/product/12.jpg";

const ListDatatable = ({ id, myData, myClass }) => {
  const [data, setData] = useState();
  const result = useSelector((state) => state.admin);
  const { loginAdmin } = result || {};
  const { role } = loginAdmin || [];

  useEffect(() => {
    setData(myData);
  }, [myData]);
  const handleStatusTextColor = (row) => {
    return {
      color:
        row.status === "PENDING"
          ? "orange"
          : row.status === "ACCEPTED"
          ? "green"
          : row.status === "REJECTED"
          ? "red"
          : row.status === "CANCELLED"
          ? "#301CA0"
          : "#ffc60b",
      fontWeight: "bold",
      textTransform: "capitalize",
    };
  };

  const columnDefs = [
    {
      name: "Requester User Name",
      selector: (row) => row?.requesterId?.username,
      sortable: true,
    },
    {
      name: "Requester product",
      cell: (row) => (
        <ProductDetails
          image={
            row.requesterProduct ? row?.requesterProduct?.image : placeholder
          }
          name={row?.requesterProduct?.name}
          price={row?.requesterProduct?.price}
        />
      ),
      sortable: true,
      width: "225px",
    },
    {
      name: "Rceipient User Name",
      selector: (row) => row?.receiverId?.username,
      sortable: true,
    },
    {
      name: "Receiver product",
      cell: (row) => (
        <ProductDetails
          image={
            row.receiverProduct ? row?.receiverProduct?.image : placeholder
          }
          name={row?.receiverProduct?.name}
          price={row?.receiverProduct?.price}
        />
      ),
      sortable: true,
    },
    {
      name: "Trade Status",
      selector: (row) => (
        <span style={handleStatusTextColor(row)}>{row?.status}</span>
      ),
      sortable: true,
    },
    {
      name: "Date/Time",
      selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
  ];

  let editRole = role?.some((r) =>
    ["suUsers", "superAdmin", "writeDeposits"].includes(r)
  );

  useEffect(() => {
    const check = editRole;
    if (!check) {
      columnDefs.pop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnDefs]);

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

const ProductDetails = ({ image, name, price }) => {
  return (
    <div className="profile-image">
      <img src={image} alt="logo" />
      <p>{name || "Product Name"}</p>
      <p>
        <b>€ {price?.toFixed(2)}</b>
      </p>
    </div>
  );
};

export default ListDatatable;
